import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import {
  UitkSubHeadingTags,
  UitkTypeHyphens,
  UitkTypeOverflows
} from "./types.js";
export function UitkSubheading({
  className,
  children,
  tag,
  overflow,
  hyphens,
  style,
  ...attributes
}) {
  const defaultTag = "p";
  const Tag = tag && UitkSubHeadingTags.get(tag) || defaultTag;
  const wrapperClassNames = classNames(
    "uitk-subheading",
    overflow && UitkTypeOverflows.get(overflow),
    hyphens && UitkTypeHyphens.get(hyphens),
    className
  );
  return children ? /* @__PURE__ */ React.createElement(Tag, { className: wrapperClassNames, style, ...attributes }, children) : null;
}
;
